import { Users, Plus, Minus } from 'lucide-react';
import { Button } from '@paulownia/shared/components/ui/button';

interface ServingSelectorProps {
    servings: number;
    onServingsChange: (servings: number) => void;
}

/**
 * Serving selector for WEIGHT_ESTIMATED products.
 * Allows customer to select number of persons with +/- stepper.
 */
export function ServingSelector({
    servings,
    onServingsChange,
}: ServingSelectorProps) {
    const handleChange = (delta: number) => {
        const newValue = Math.max(1, servings + delta);
        onServingsChange(newValue);
    };

    return (
        <div className="space-y-3">
            <div className="flex items-center justify-center gap-2 text-gray-700">
                <Users className="w-4 h-4" />
                <span className="text-sm font-medium">Nombre de personnes</span>
            </div>
            <div className="flex items-center justify-center gap-4">
                <Button
                    variant="outline"
                    size="icon"
                    onClick={() => handleChange(-1)}
                    disabled={servings <= 1}
                    className="w-10 h-10"
                >
                    <Minus className="w-4 h-4" />
                </Button>
                <div className="min-w-[80px] text-center">
                    <span className="text-2xl font-bold text-gray-900">{servings}</span>
                    <span className="text-sm text-gray-500 ml-1">pers</span>
                </div>
                <Button
                    variant="outline"
                    size="icon"
                    onClick={() => handleChange(1)}
                    className="w-10 h-10"
                >
                    <Plus className="w-4 h-4" />
                </Button>
            </div>
        </div>
    );
}
